// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"337":"perfil","644":"conta","731":"trilha","747":"ranking","796":"duelo","827":"hoje"}[chunkId] + "." + {"337":"b140c1f9","644":"42eee19f","731":"d683b126","747":"4a9b2fa7","796":"9c1b011e","827":"348b0bbb"}[chunkId] + ".css";
};